
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  groupCsList,
  delGroupCs
} from '@/api/group';
import { getWithAuthority } from '@/api/customer';
import { getDepartmentList } from '@/api/company';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/index';

import DialogSelectGroup from './components/CustomerGroupsDialog.vue'

@Component({
  name: 'CustomerGroupsView',
  components: {
    DialogSelectGroup
  }
})
export default class extends Vue {
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private page = 1;
  private size = 10;

  private formSearch = {
    customer: '',
    dept: '',
    staff: ''
  };
  private tableData = [];
  private listLoading = false;
  // private userSelectedAll= false; // 全选中
  // private isIndeterminate= false; // 全选框 模糊状态

  //  private deptSelectedAll= false; // 全选中
  // private isDeptIndeterminate= false; // 全选框 模糊状态

  // private customerVisible = false;
  // private isCheckbox = true;
  // private dialogSelectDeptStaffVisible = false;
  // private radioDeptStaff = '11';
  // private formDeptDept = {
  //   name: ''
  // };
  // private dataTableDept:any = [];

  // private dataTableStaff:any = [];
  // private formDeptStaff = {
  //   name: '',
  //   phone: ''
  // };

  // 新版
  private dialogGroupsVisible:Boolean = false
  private dialogGroupsClose(val: Boolean) {
    this.dialogGroupsVisible = val
  }
  private selectedGroup() {
    this.getAuthGroup();
  }

  created() {
    this.getAuthGroup();
  }

  handleCurrentChange(size: number) {
    this.page = size;
    this.getAuthGroup();
  }

  handlePageSizeChange(size: number) {
    this.size = size;
    this.getAuthGroup();
  }
  // 搜索
  private handleSearch() {
    this.page = 1;
    this.getAuthGroup();
  }

  // 清空
  private handleSearchClear() {
    this.page = 1;
    this.formSearch = {
      customer: '',
      dept: '',
      staff: ''
    };
    this.getAuthGroup();
  }

  private getAuthGroup() {
    this.listLoading = true;
    // group_state 查看客户群组权限: 1 客户别名推单群组: 5
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      customer_name: this.formSearch.customer,
      department_name: this.formSearch.dept,
      engineer_user_name: this.formSearch.staff,
      page: this.page,
      size: this.size,
      group_type: 1
    };
    groupCsList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.tableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  private editData: any = {};
  private isDefaultGroup: any = '0'

  private addOperationhandle() {
    // this.multipleUserSelection = [];
    // this.multipleDeptSelection = [];
    // this.customerVisible = true;
    this.isDefaultGroup = '0';
    this.editData = {};
    this.dialogGroupsVisible = true
  }

  private addAllHandle() {
    this.isDefaultGroup = '1';
    this.editData = {};
    this.dialogGroupsVisible = true
    // this.dialogSelectDeptStaffVisible = true;
    // this.deptPage = 1;
    // this.userPage = 1;
    // this.getUserList();
    // this.getDepartmentList();
  }
  private operationAllHandle(val: any) {
    this.isDefaultGroup = '1';
    this.editData = val;
    this.dialogGroupsVisible = true
    // if (this.editData && this.editData.push_type) {
    //   if (parseInt(this.editData.push_type) === 11) {
    //     this.radioDeptStaff = '11'; // 人员
    //     this.multipleUserSelection = this.editData.userList;
    //     this.multipleDeptSelection = [];
    //   } else {
    //     this.radioDeptStaff = '10'; // 部门
    //     this.multipleDeptSelection = this.editData.deptList;
    //     this.multipleUserSelection = [];
    //   }
    // }
    // this.dialogSelectDeptStaffVisible = true;
    // this.deptPage = 1;
    // this.userPage = 1;
    // this.getUserList();
    // this.getDepartmentList();
  }

  private operationhandle(val: any) {
    this.isDefaultGroup = '0';
    this.editData = val;
    this.dialogGroupsVisible = true
    // this.customerVisible = true;
  }

  // private closeSelectCustomerHandle() {
  // this.selectCusromer = [];
  // this.editData = {};
  // this.customerVisible = false;
  // }

  // 下一步
  // private selectCustomerHandle(value: any) {
  // if (this.editData && this.editData.push_type) {
  //   if (parseInt(this.editData.push_type) === 11) {
  //     this.radioDeptStaff = '11'; // 人员
  //     this.multipleUserSelection = this.editData.userList;
  //     this.multipleDeptSelection = [];
  //   } else {
  //     this.radioDeptStaff = '10'; // 部门
  //     this.multipleDeptSelection = this.editData.deptList;
  //     this.multipleUserSelection = [];
  //   }
  // }
  // this.selectCusromer = value;
  // this.dialogSelectDeptStaffVisible = true;
  // this.deptPage = 1;
  // this.userPage = 1;
  // this.getUserList();
  // this.getDepartmentList();
  // }

  // private userMore = false;
  // private userMoreLoading = false;
  // private userPage = 1;

  // private userMoreClick() {
  //   this.userPage++;
  //   this.getUserList();
  // }

  // private serchUser() {
  //   this.userPage = 1;
  //   this.getUserList();
  // }

  // private cleanSerchUser() {
  //   this.formDeptStaff = { name: '', phone: '' };
  //   this.userPage = 1;
  //   this.getUserList();
  // }

  // 所有人员接口
  // private selectUserId:any=[]
  // private SelectedAll() {
  //   if (this.userSelectedAll) {
  //     // 全选
  //     for (let i = 0; i < this.dataTableStaff.length; i++) {
  //       let index = this.selectUserId.indexOf(this.dataTableStaff[i].id);
  //       if (index === -1) {
  //         this.selectUserId.push(this.dataTableStaff[i].id);
  //         this.multipleUserSelection.push(this.dataTableStaff[i]);
  //       }
  //     }
  //     this.userSelectedAll = true;
  //     this.isIndeterminate = false;
  //   } else {
  //     // 全不选
  //     this.selectUserId = [];
  //     this.multipleUserSelection = [];
  //   }
  // }
  // private userSelection(item:any) {
  //   let select:any = this.selectUserId.filter((id:any) => {
  //     return id === item.id;
  //   });
  //   if (select && select.length > 0) {
  //     this.multipleUserSelection.push(item);
  //   } else {
  //     for (let i = 0; i < this.multipleUserSelection.length; i++) {
  //       if (this.multipleUserSelection[i].id === item.id) {
  //         this.multipleUserSelection.splice(i, 1);
  //         break;
  //       }
  //     }
  //   }
  //   if (this.selectUserId.length === this.dataTableStaff.length) {
  //     this.userSelectedAll = true;
  //     this.isIndeterminate = false;
  //   } else if (this.selectUserId.length === 0) {
  //     this.userSelectedAll = false;
  //     this.isIndeterminate = false;
  //   } else {
  //     this.userSelectedAll = false;
  //     this.isIndeterminate = true;
  //   }
  // }
  // getUserList() {
  //   const params = {
  //     user_id: UserModule.getUserId,
  //     company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //     username: this.formDeptStaff.name,
  //     mobile: this.formDeptStaff.phone,
  //     size: 10,
  //     page: this.userPage
  //   };
  //   getWithAuthority(params)
  //     .then((res) => {
  //       if (res.data) {
  //         if (this.userPage === 1) {
  //           this.dataTableStaff = res.data.list;
  //         } else {
  //           this.dataTableStaff = this.dataTableStaff.concat(...res.data.list);
  //         }
  //         if (this.userPage < res.data.page_count) {
  //           this.userMore = true;
  //         } else {
  //           this.userMore = false;
  //         }
  //         let that = this;
  //         this.$nextTick(function() {
  //           if (that.multipleUserSelection && that.multipleUserSelection.length > 0) {
  //             that.multipleUserSelection.forEach((ser:any) => {
  //               let have:any = [];
  //               if (that.dataTableStaff) {
  //                 have = that.dataTableStaff.filter((v:any) => {
  //                   return v.id === ser.id;
  //                 });
  //               }
  //               if (have && have.length > 0) {
  //                 that.selectUserId.push(have[0].id);
  //               }
  //             });
  //           }
  //         });
  //       } else {
  //         this.dataTableStaff = [];
  //       }
  //     })
  //     .catch((err) => {
  //       let msg = err.msg;
  //       this.dataTableStaff = [];
  //       this.userPage = 1;
  //     });
  // }

  // private multipleUserSelection: any = [];

  // private tagUserClose(val: any) {
  //   this.multipleUserSelection.splice(
  //     this.multipleUserSelection.indexOf(val),
  //     1
  //   );
  //   this.selectUserId.splice(
  //     this.selectUserId.indexOf(val.id),
  //     1
  //   );
  //   if (this.selectUserId.length === this.dataTableStaff.length) {
  //     this.userSelectedAll = true;
  //     this.isIndeterminate = false;
  //   } else if (this.selectUserId.length === 0) {
  //     this.userSelectedAll = false;
  //     this.isIndeterminate = false;
  //   } else {
  //     this.userSelectedAll = false;
  //     this.isIndeterminate = true;
  //   }
  // }

  // private deptMore = false;
  // private deptMoreLoading = false;
  // private deptPage = 1;

  // private deptMoreClick() {
  //   this.deptPage++;
  //   this.getDepartmentList();
  // }

  // private serchDept() {
  //   this.deptPage = 1;
  //   this.getDepartmentList();
  // }

  // private cleanSerchDept() {
  //   this.formDeptDept = { name: '' };
  //   this.deptPage = 1;
  //   this.getDepartmentList();
  // }

  //
  // private selectDeptId:any=[]
  // private deptSelectedAllchange() {
  //   if (this.deptSelectedAll) {
  //     // 全选
  //     for (let i = 0; i < this.dataTableDept.length; i++) {
  //       let index = this.selectDeptId.indexOf(this.dataTableDept[i].id);
  //       if (index === -1) {
  //         this.selectDeptId.push(this.dataTableDept[i].id);
  //         this.multipleDeptSelection.push(this.dataTableDept[i]);
  //       }
  //     }
  //     this.deptSelectedAll = true;
  //     this.isDeptIndeterminate = false;
  //   } else {
  //     // 全不选
  //     this.selectDeptId = [];
  //     this.multipleDeptSelection = [];
  //   }
  // }
  // private deptSelection(item:any) {
  //   let select:any = this.selectDeptId.filter((id:any) => {
  //     return id === item.id;
  //   });
  //   if (select && select.length > 0) {
  //     this.multipleDeptSelection.push(item);
  //   } else {
  //     for (let i = 0; i < this.multipleDeptSelection.length; i++) {
  //       if (this.multipleDeptSelection[i].id === item.id) {
  //         this.multipleDeptSelection.splice(i, 1);
  //         break;
  //       }
  //     }
  //   }
  //   if (this.selectDeptId.length === this.dataTableDept.length) {
  //     this.deptSelectedAll = true;
  //     this.isDeptIndeterminate = false;
  //   } else if (this.selectUserId.length === 0) {
  //     this.deptSelectedAll = false;
  //     this.isDeptIndeterminate = false;
  //   } else {
  //     this.deptSelectedAll = false;
  //     this.isDeptIndeterminate = true;
  //   }
  // }
  // private getDepartmentList() {
  //   const params: any = {
  //     company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //     type: '9', // type=9 查所有部门  type=2查服务部门
  //     size: 10,
  //     page: this.deptPage
  //   };
  //   if (this.formDeptDept.name) {
  //     params.name = this.formDeptDept.name;
  //   }
  //   getDepartmentList(params)
  //     .then((res) => {
  //       if (res.data) {
  //         if (this.deptPage === 1) {
  //           this.dataTableDept = res.data.list;
  //         } else {
  //           this.dataTableDept = this.dataTableDept.concat(...res.data.list);
  //         }
  //         if (this.deptPage < res.data.page_count) {
  //           this.deptMore = true;
  //         } else {
  //           this.deptMore = false;
  //         }
  //       } else {
  //         this.dataTableDept = [];
  //       }
  //       this.paseData(this.dataTableDept);
  //     })
  //     .catch((err) => {
  //       let msg = err.msg;
  //       this.dataTableDept = [];
  //       this.deptPage = 1;
  //     });
  // }

  // private paseData(val: any) {
  //   for (let i = 0; i < val.length; i++) {
  //     let cont: any = val[i];
  //     cont.area =
  //       val[i].province_name + val[i].city_name + val[i].district_name;
  //     cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
  //     this.$set(this.dataTableDept, cont, i);
  //   }
  //   let that = this;
  //   this.$nextTick(function() {
  //     if (that.multipleDeptSelection && that.multipleDeptSelection.length > 0) {
  //       that.multipleDeptSelection.forEach((ser:any) => {
  //         let have:any = [];
  //         if (that.dataTableStaff) {
  //           have = that.dataTableDept.filter((v:any) => {
  //             return v.id === ser.id;
  //           });
  //         }
  //         if (have && have.length > 0) {
  //           that.selectDeptId.push(have[0].id);
  //         }
  //       });
  //     }
  //   });
  // }

  // private multipleDeptSelection: any = [];

  // private tagDeptClose(val: any) {
  //   this.multipleDeptSelection.splice(
  //     this.multipleDeptSelection.indexOf(val),
  //     1
  //   );
  //   this.selectDeptId.splice(
  //     this.selectDeptId.indexOf(val.id),
  //     1
  //   );
  //   if (this.selectDeptId.length === this.dataTableDept.length) {
  //     this.deptSelectedAll = true;
  //     this.isDeptIndeterminate = false;
  //   } else if (this.selectUserId.length === 0) {
  //     this.deptSelectedAll = false;
  //     this.isDeptIndeterminate = false;
  //   } else {
  //     this.deptSelectedAll = false;
  //     this.isDeptIndeterminate = true;
  //   }
  // }

  // private selectCusromer: any = [];

  // private dialogSelectDeptStaffColose() {
  // this.radioDeptStaff = '10'; // dept
  // this.multipleUserSelection = [];
  // this.multipleDeptSelection = [];
  // this.dialogSelectDeptStaffVisible = false;
  // }

  private addAuthGroup() {
  //   if (parseInt(this.radioDeptStaff) === 10) {
  //     // 部门
  //     if (this.multipleDeptSelection.length < 1) {
  //       this.showErrorMsg('请选择部门');
  //       return;
  //     }
  //   } else {
  //     // 人员
  //     if (this.multipleUserSelection.length < 1) {
  //       this.showErrorMsg('请选择人员');
  //       return;
  //     }
  //   }
  //   var v = '';
  //   if (this.editData.group_name) {
  //     v = this.editData.group_name;
  //   }
  //   this.$prompt('名称', '群组名称', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     inputPlaceholder: '请输入群组名称',
  //     inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,30}$/,
  //     inputErrorMessage: '请输入2-30位由数字、字母、中文组成的名称',
  //     inputValue: v
  //   })
  //     .then(({ value }: any) => {
  //       const params:any = {
  //         user_id: UserModule.getUserId,
  //         company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //         group_name: value,
  //         group_type: '1',
  //         is_default_group: this.isDefaultGroup // parseInt(params.is_default_group) === 1 新建查看所有客户群组
  //       };

    //       let customers:any = [];
    //       this.selectCusromer.forEach((element:any) => {
    //         let customer:any = {};
    //         customer.user_id = element.customer_user_id;
    //         customer.user_name = element.name;
    //         customer.company_id = element.customer_company_id;
    //         customer.company_name = element.name;
    //         customer.type = element.customer_type;
    //         customers.push(customer);
    //       });
    //       params.customer = JSON.stringify(customers);
    //       // 报修维修类型 10服务部门推送 11维修工程师推送

    //       if (parseInt(this.radioDeptStaff) === 10) {
    //         // 部门
    //         let depts:any = [];
    //         this.multipleDeptSelection.forEach((element:any) => {
    //           if (element.dept_id) {
    //             let dept:any = {};
    //             dept.id = element.dept_id;
    //             dept.name = element.name;
    //             depts.push(dept);
    //           } else {
    //             let dept:any = {};
    //             dept.id = element.id;
    //             dept.name = element.name;
    //             depts.push(dept);
    //           }
    //         });
    //         params.push_type = '10';
    //         params.servicer_department = JSON.stringify(depts);
    //       } else {
    //         // 人员
    //         let users:any = [];
    //         this.multipleUserSelection.forEach((element:any) => {
    //           let user:any = {};
    //           user.user_id = element.id;
    //           user.user_name = element.name;
    //           users.push(user);
    //         });
    //         params.push_type = '11';
    //         params.engineer_user = JSON.stringify(users);
    //       }

  //       if (this.editData && this.editData.id) {
  //         params.group_id = this.editData.id;
  //         this.edit(params);
  //       } else {
  //         this.add(params);
  //       }
  //     })
  //     .catch(() => {
  //       // this.$message({
  //       //   type: 'info',
  //       //   message: '取消输入'
  //       // });
  //     });
  }
  private deleteAuthGroup(val: any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          group_id: val.id
        };
        delGroupCs(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getAuthGroup();
          })
          .catch((err) => {
            this.showErrorMsg(err);
          });
      })
      .catch(() => {});
  }

  // private add(params: any) {
  //   addGroupCs(params)
  //     .then((res) => {
  //       this.customerVisible = false;
  //       this.dialogSelectDeptStaffVisible = false;
  //       this.showSuccessMsg('添加成功');
  //       this.getAuthGroup();
  //     })
  //     .catch((err) => {
  //       this.showErrorMsg(err);
  //     });
  // }

  // private edit(params:any) {
  //   editGroupCs(params)
  //     .then((res) => {
  //       this.customerVisible = false;
  //       this.dialogSelectDeptStaffVisible = false;
  //       this.showSuccessMsg('修改成功');
  //       this.getAuthGroup();
  //     })
  //     .catch((err) => {
  //       this.showErrorMsg(err);
  //     });
  // }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
